export function now(): number {
  return Math.floor(performance.now());
}

export default class Timer {
  private readonly start: number;
  private end: number | undefined;

  constructor() {
    this.start = now();
  }
  getStart(): number {
    return this.start;
  }

  getEnd(): number {
    return this.end || 0;
  }

  stop(): number {
    this.end = now();
    return this.start + this.end;
  }
}
